import Event from "../../types/Event";
import { saveEventViaCallable } from "./eventLinks";

// The write happens in the adminSaveEvent callable: a gated event's meetingURL
// and replayURL must land in the protected subdoc, which no client can write.
export default async ({ event, notify }: { event: Event; notify: boolean }) => {
  const payload: any = { ...event };
  delete payload.id;
  delete payload.image;
  delete payload.imagecoverURL;
  // UI state only. It must never reach Firestore. Unlike editEvent there is no
  // URL strip here: a new event has no stored links to protect, so the form
  // seeds protectedLinksLoaded true and both boxes hold what the admin typed.
  delete payload.protectedLinksLoaded;
  return saveEventViaCallable({ event: payload, notify });
};
